import { Asset } from '../../common/model/Assets';
export default class ProjectPublicationsIdTranslations {
    constructor(translation) {
        const { id, link, file, name } = translation;
        this.id = id;
        this.link = link !== null && link !== void 0 ? link : '';
        this.file = file ? new Asset(file) : undefined;
        this.name = name !== null && name !== void 0 ? name : '';
    }
}
